import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 8v3a1 1 0 0 0 1 1h3","key":"svg-0"}],["path",{"d":"M18 8v8","key":"svg-1"}],["path",{"d":"M6 8h4l-2 8","key":"svg-2"}]]

const IconNumber74Small = createReactComponent('outline', 'number-74-small', 'Number74Small', __iconNode);

export default IconNumber74Small;